import { render, staticRenderFns } from "./PoyntProvider.vue?vue&type=template&id=25ca9d5c&"
import script from "./PoyntProvider.vue?vue&type=script&lang=ts&"
export * from "./PoyntProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports